module.exports = __webpack_public_path__ + "img/Ingles II.c6eaac77.png";